import axios from 'axios';

import { BASE_API_URL, userService } from '../_services';
import { authHeader, router } from '../_helpers';
import { store } from '../_store/index';


function getDrugCombinationsReportData(farmId, seasonStartYear)
{
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/reports/drug_combinations?farm_id=${escape(farmId)}&season_start_year=${escape(seasonStartYear)}`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function getDrugChartReportData(clientId)
{
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/reports/drug_chart?client_id=${escape(clientId)}`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function getReportData(searchType, farmId, category) {
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/reports/${escape(searchType)}?farm_id=${escape(farmId)}&category=${escape(category)}`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function getFonterraReportData(clientId, farmId, season) {
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/reports/${clientId}/fonterra/${farmId}/season/${season}`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}

function storeFonterraReportData(clientId, farmId, season, data) {
  return axios({
    method: 'post',
    url: `${BASE_API_URL}/reports/${clientId}/fonterra/${farmId}/season/${season}/create`,
    headers: authHeader(),
    data: data,
  }).catch(handleResponse)
    .then(response => response.data)
}


function getWinterConsultSummaryReportData(clientId, season) {
  return axios({
    method: 'get',
    url: `${BASE_API_URL}/reports/wc_summary/${clientId}/${season}/export_pdf`,
    headers: authHeader()
  }).catch(handleResponse)
    .then(response => response.data)
}


function getReportFarms(search, search_type) {
    return axios({
        method: 'get',
        url: `${BASE_API_URL}/reports/farms/?q=${escape(search)}&by=${escape(search_type)}`,
        headers: authHeader()
    }).catch(handleResponse)
        .then(response => response.data)
}


function handleResponse(error) {
  if (error.response.status == 401) {
    store.dispatch('alert/error', {message: 'Your session has expired.'}, { root: true });
    userService.logout()
    router.push('/login')
  } else if (error.response.status == 403) {
    store.dispatch('alert/error', {message: 'Your vet user code has not been set in EzyVet please see Keyvet admin'}, { root: true });
  }
  return Promise.reject(error)
}


export const reportService = {
  getReportData,
  getReportFarms,
  getWinterConsultSummaryReportData,
  getFonterraReportData,
  storeFonterraReportData,
  getDrugChartReportData,
  getDrugCombinationsReportData,
};
